import script from "./lessonsList.vue?vue&type=script&setup=true&lang=js"
export * from "./lessonsList.vue?vue&type=script&setup=true&lang=js"

import "./lessonsList.vue?vue&type=style&index=0&id=a75eafee&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a75eafee"]])

export default __exports__